<template>
    <rkm-modal
        ref="RkmModal"
        title="Justificativa da interrupção do tratamento"
    >
        <rkm-form ref="RkmForm">
            <rkm-row>
                <rkm-col>
                    <rkm-form-textarea
                        :validations="validations.justificativa"
                        name="Justificativa da interrupção do tratamento"
                        rows="4"
                        v-model="model.justificativa"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <template v-slot:footer="{cancel}">
            <rkm-button @click="cancel">
                Fechar
            </rkm-button>

            <rkm-button
                @click="save"
                color="primary"
            >
                Salvar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Mixins.
import {object} from '@/mixins'

export default {
    computed: {
        validations() {
            return {
                justificativa: {
                    required: true,
                    max: 500,
                },
            }
        },
    },
    data: () => ({
        item: null,
        model: {
            justificativa: null,
        },
    }),
    methods: {
        open(item) {
            this.item = item

            this.create()

            this.$refs.RkmModal.show()
        },
        create() {
            this.resetForm()
        },
        store() {
            this.data.model.medicamentosEmUso.medicamentosComTratamentoInterrompido.push({
                prescricaoMedicamentoItemId: this.item.id,
                justificativa: this.model.justificativa,
            })
        },
        save() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    this.store()

                    this.$refs.RkmModal.hide()
                })
        },
        resetForm() {
            this.model.justificativa = null
        },
    },
    mixins: [object],
    props: {
        data: {required: true, type: Object},
    },
}
</script>